import React, { useState } from 'react';
import { ui } from './toolTheme';

const Base64ToolPage = ({ setPage }) => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');

  const encode = () => {
    setError('');
    try {
      setOutput(btoa(unescape(encodeURIComponent(input))));
    } catch (e) {
      setError('Unable to encode input.');
    }
  };

  const decode = () => {
    setError('');
    try {
      setOutput(decodeURIComponent(escape(atob(input.trim()))));
    } catch (e) {
      setError('Invalid Base64 input.');
    }
  };

  return (
    <main style={ui.page}>
      <div style={ui.container}>
        <button onClick={() => setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>

        <div style={ui.card}>
          <h1 style={ui.sectionTitle}>Base64 Encoder / Decoder</h1>
          <p style={ui.sectionSub}>Encode plain text to Base64 or decode Base64 back to text.</p>
        </div>

        <div style={{ ...ui.card, marginTop: 18 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <textarea value={input} onChange={(e) => setInput(e.target.value)} rows={14} placeholder="Input"
              style={{ ...ui.textarea, ...ui.mono, fontSize: 13 }} />
            <textarea value={output} readOnly rows={14} placeholder="Output"
              style={{ ...ui.textarea, ...ui.mono, fontSize: 13 }} />
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
            <button onClick={encode} style={ui.primaryBtn}>Encode</button>
            <button onClick={decode} style={ui.secondaryBtn}>Decode</button>
            <button onClick={() => navigator.clipboard.writeText(output || '')} style={ui.secondaryBtn}>Copy Output</button>
          </div>

          {error && <div style={ui.error}>{error}</div>}
        </div>
      </div>
    </main>
  );
};

export default Base64ToolPage;
